import React, { useState } from 'react';
import HomeownerOnboarding from './HomeownerOnboarding';
import { useTheme } from '../ThemeContext';

const client = {
  id: '00000000-0000-4000-8000-000000000001',
  agent_id: null,
  address: '123 Main St',
  property_type: 'single_family',
  features: [],
};

/**
 * Development screenshot for the homeowner "Add an item" setup step.
 * Production builds never mount this. Query: ?preview=setup-item
 */
export default function SetupItemPreview() {
  const { colors } = useTheme();
  const [result, setResult] = useState(null);
  if (result) {
    const skipped = Boolean(result.skipped);
    return (
      <div
        role="status"
        style={{
          minHeight: '100dvh',
          background: colors.background,
          color: colors.text,
          boxSizing: 'border-box',
          paddingTop: 'calc(env(safe-area-inset-top, 0px) + 2.5rem)',
          paddingRight: 'calc(env(safe-area-inset-right, 0px) + 1.25rem)',
          paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 2rem)',
          paddingLeft: 'calc(env(safe-area-inset-left, 0px) + 1.25rem)',
        }}
      >
        <h1 style={{ fontSize: '1.75rem', fontWeight: 700, letterSpacing: '-0.02em', margin: '0 0 0.5rem' }}>
          {skipped ? 'Skipped for now' : 'Setup complete'}
        </h1>
        <p style={{ margin: 0, color: colors.textSecondary, fontSize: '1.05rem', lineHeight: 1.4 }}>
          {skipped
            ? 'No items were added. You can add them later.'
            : 'Your home is ready. You can add items later.'}
        </p>
      </div>
    );
  }
  return (
    <HomeownerOnboarding
      client={client}
      startAtItemForm
      onComplete={(info) => setResult(info || { skipped: false })}
    />
  );
}
